import { reactive } from 'vue';

export const criarProcModelo = () => {
    return reactive({
        id: 0,
        idep: 0,
        idepmenuproc: 0,
        cdmodelo: '',
        nmprocesso: '',
        descricao: '',
        ativo: 'S',
        cksim: 'N',
        ckestabelecimento: 'N',
        ckproduto: 'N',
        ckrotulo: 'N',
        idlogin: 0,
    })
}
